import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
    name: 'safe',
    standalone: true,
})
export class SafePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {
    }

    public transform(url: string | undefined | null) {
        if (! url) return
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    }
}
